import { property } from "../dataStruct";

export interface LegParam {
  type: property;
  value: string;
  json: string;
}
export interface WantedLeg {
  legId: string;
  actOverflyTime: number;
  params: LegParam[];
}
export interface StoredLegRow {
  legId: string;
  actOverflyTime?: number | null;
}
export interface StoredParamRow {
  parameterHash: string;
  paramTypeId: property | string;
  paramValString?: string | null;
  paramValJson?: string | null;
}
export interface LegWrites {
  rows: { legId: string; actOverflyTime: number }[];
  params: ({ legId: string } & LegParam)[];
  obsolete: string[];
}

export function legWrites(wanted: WantedLeg[], storedLegs: StoredLegRow[], storedParams: StoredParamRow[]): LegWrites {
  const result: LegWrites = { rows: [], params: [], obsolete: [] };
  const legs = new Map<string, StoredLegRow>();
  for (const l of storedLegs) legs.set(l.legId, l);
  const params = new Map<string, StoredParamRow>();
  for (const p of storedParams) {
    params.set(`${p.parameterHash}|${String(p.paramTypeId)}`, p);
  }
  const wantedIds = new Set<string>();
  for (const w of wanted) {
    wantedIds.add(w.legId);
    const stored = legs.get(w.legId);
    if (!stored || (stored.actOverflyTime ?? 0) !== w.actOverflyTime) {
      result.rows.push({ legId: w.legId, actOverflyTime: w.actOverflyTime });
    }
    for (const p of w.params) {
      const sp = stored ? params.get(`${w.legId}|${String(p.type)}`) : undefined;
      if (!sp || (sp.paramValString ?? "") !== p.value || (sp.paramValJson ?? "") !== p.json) {
        result.params.push({ legId: w.legId, ...p });
      }
    }
  }
  for (const l of storedLegs) {
    if (!wantedIds.has(l.legId)) result.obsolete.push(l.legId);
  }
  return result;
}
